import {
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    Input,
    Output,
    EventEmitter,
    AfterViewInit,
    OnChanges
} from '@angular/core';
import {TpDocumento} from '../../model/tpDocumento';
import {PacDocumentos} from '../../model/pack-documentos';
import {FormGroup, FormBuilder, FormControl, Validators} from '@angular/forms';
import {MatTableDataSource, MatDialog} from '@angular/material';
import {SelectionModel} from '@angular/cdk/collections';
import {Router} from '@angular/router';
import {DocumentoService} from '../../service/documento.service';
import {EventEmitService} from 'src/app/service/event-emit.service';
import {NgBlockUI, BlockUI} from 'ng-block-ui';
import {CredorDTO} from '../../model/dto/credor.dto';
import {CredorService} from '../../service/credor.service';
import {ToasterService} from 'angular2-toaster';
import {AnyRecord} from 'dns';
import {ConfirmarDialogComponent} from "../../pages/util/confirmar-dialog/confirmar-dialog.component";
import {ConfirmarDialogData} from "../../pages/util/confirmar-dialog/ConfirmarDialogData";
import {DialogPosition, MatDialogRef} from "@angular/material/dialog";
import {b} from "@angular/core/src/render3";
import {DocumentoDTO} from "../../model/dto/documento.dto";
import {DocumentoEmitterDTO} from "../../model/dto/DocumentoEmitterDTO";
import {emit} from "cluster";


const PROTOCOLO = 'SessionProtocolo';

@Component({
    selector: 'app-anexar-documentos-comprobatorios',
    templateUrl: './anexar-documentos-comprobatorios.component.html',
    styleUrls: ['./anexar-documentos-comprobatorios.component.css']
})
export class AnexarDocumentosComprobatoriosComponent implements OnInit, OnChanges {

    pageSize = 10;
    total: number;
    pageSizeOption: number[] = [5, 10, 25, 100];

    fileAnexos: DocumentoDTO[] = [];
    tamanhoMaximoArquivo: number = 5000000; // 5 MB
    file: File;
    arquivoAnexo: DocumentoDTO;
    fileReader: FileReader = null;
    tipoDocumento: string;
    pacDocumentos: PacDocumentos;
    mostrarDesricao: boolean = false;
    formGroupAnexar: FormGroup;
    credor: CredorDTO;
    isPessoaFisica: boolean = false;
    isContaTerceiro: boolean = false;
    isProcRepl: boolean = false;
    isRecuperar = false;
    deletedKeys = [];
    @Input() tipoCredorInput: number;
    @ViewChild('arquivoAnexado')
    arquivoAnexado: ElementRef;
    @Input() identificador: string;
    @Input() idSolicitacao: number;
    tipoDocumentos = new Array<TpDocumento>();
    @Input() protocolo: any;
    @Output() paginaAnterior = new EventEmitter();
    @Output() habilitarStep4 = new EventEmitter();
    //@Output() documentos:DocumentoDTO[] = [];
    @BlockUI() blocker: NgBlockUI;
    @Output() documentos = new EventEmitter<DocumentoEmitterDTO>();
    @Input()
    displayedColumns: string[];

    @Input() documentosInput: DocumentoDTO[] = [];
    @Input() isViewMode: Boolean = true;

    dataSource = new MatTableDataSource<DocumentoDTO>();
    selection = new SelectionModel<DocumentoDTO>(true, []);
    @Input()
    edicao: boolean;
    @Input()
    documentoExcluido: EventEmitter<any> = new EventEmitter<any>();

    listCodDocumentosExibirCredor0: Array<number> = [1, 2, 6, 7];

    listCodDocumentosExibirCredor1: Array<number> = [1, 2, 3, 6];


    constructor(private _formBuilder: FormBuilder, private documentoService: DocumentoService,
                private route: Router,
                private credorservice: CredorService,
                private toastService: ToasterService,
                public dialog: MatDialog) {
    }

    ngOnInit() {
        this.montarForm();
        this.fileAnexos = this.documentosInput.filter(doc => doc.tipoDocumento.id !== 8);
        this.dataSource.data = this.fileAnexos;
    }

    ngOnChanges() {
        this.documentoService.getTipoDocumento().subscribe(response => {
            const tpDocumentos = response as TpDocumento[];
            if (this.tipoCredorInput === undefined || this.tipoCredorInput === 0) {
                this.tipoDocumentos = new Array<TpDocumento>();
                for (const tpDocumento of tpDocumentos) {
                    if (this.listCodDocumentosExibirCredor0.includes(tpDocumento.id)) {
                        this.tipoDocumentos.push(tpDocumento);
                    }
                }
            }
            if (this.tipoCredorInput === 1) {
                this.tipoDocumentos = new Array<TpDocumento>();
                for (const tpDocumento of tpDocumentos) {
                    if (this.listCodDocumentosExibirCredor1.includes(tpDocumento.id)) {
                        this.tipoDocumentos.push(tpDocumento);
                    }
                }
            }
            this.tipoDocumentos = this.tipoDocumentos.filter(tipo => 
                !this.documentosInput.some(documento => documento.tipoDocumento.id === tipo.id)
            );
        });
    }

    montarForm() {
        this.formGroupAnexar = this._formBuilder.group({
            tipoDocumento: new FormControl([Validators.required]),
            descricao: new FormControl()
        });
    }

    montarPackDocumentos(documentos: DocumentoDTO[]) {

        this.pacDocumentos = new PacDocumentos();
        this.pacDocumentos.descricao = [];
        this.pacDocumentos.tipoDocumento = [];
        this.pacDocumentos.extensao = [];
        this.pacDocumentos.arquivo = [];

        documentos.forEach(documento => {
            this.pacDocumentos.descricao.push(documento.nomeArquivo);
            this.pacDocumentos.tipoDocumento.push(documento.tipoDocumento);
            this.pacDocumentos.extensao.push(documento.extensao);
            this.pacDocumentos.arquivo.push(documento.arquivo);
        });

    }

    fileChange(event) {
        
        const tipoDocumentoValue = this.formGroupAnexar.get('tipoDocumento').value;

        if (!tipoDocumentoValue 
            || (Array.isArray(tipoDocumentoValue) && tipoDocumentoValue.length === 0)
            || !tipoDocumentoValue.descricao) {
            this.toastService.pop('warning', 'Escolha um tipo de documento');
            return;
        }

        if (!this.formGroupAnexar.valid) {
            alert('Campos Obrigatórios não preenchidos!');
            this.toastService.pop('warning', 'Campos Obrigatórios não preenchidos!');
            return;
        }

        this.file = event.target.files[0];

        if (this.file.size > this.tamanhoMaximoArquivo) {
            this.toastService.pop('warning', 'Tamanho do anexo excede o limite permitido');
            this.file = null;
            return false;
        }

        this.arquivoAnexo = new DocumentoDTO;
        this.fileReader = new FileReader();
        this.fileReader.readAsDataURL(this.file);

        const extensao = this.file.name.substr(this.file.name.lastIndexOf('.') + 1, this.file.name.length);

        if (extensao != 'pdf') {
            alert('Formato inválido. Formato permitido PDF');
            return;
        }
        this.arquivoAnexo.extensao = extensao.toLocaleLowerCase();
        this.arquivoAnexo.arquivo = this.file;
        this.arquivoAnexo.nomeArquivo = this.file.name;
        this.arquivoAnexo.tipoDocumento = this.formGroupAnexar.get('tipoDocumento').value;

        this.fileAnexos.push(this.arquivoAnexo);

        this.dataSource.data = this.fileAnexos;
        const emiter = new DocumentoEmitterDTO();
        emiter.documento = this.arquivoAnexo;
        emiter.acao = 'incluir';
        this.documentos.emit(emiter);

        // this.mostrarDesricao = false;

        this.limparForm();

        this.retirarTipoDocLista(this.arquivoAnexo.tipoDocumento);

    }

    excluirDoc(documentoDTO: DocumentoDTO) {
        const dialogRef: MatDialogRef<ConfirmarDialogComponent, boolean> = this.dialog.open(ConfirmarDialogComponent, {
            data: {
                titulo: 'Atenção',
                botaoNao: 'Não',
                botaoSim: 'Sim',
                mensagem: 'Deseja excluir o arquivo: "' + documentoDTO.nomeArquivo + '"?'
            } as ConfirmarDialogData
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.fileAnexos = this.fileAnexos.filter(element => element !== documentoDTO);
                this.dataSource.data = this.fileAnexos;
                const emiter = new DocumentoEmitterDTO();
                emiter.documento = documentoDTO;
                emiter.acao = 'excluir';
                this.documentos.emit(emiter);
                this.formGroupAnexar.get('tipoDocumento').setValue('');
                this.tipoDocumentos.push(documentoDTO.tipoDocumento);
            }
        });
    }

    limparForm() {
        this.formGroupAnexar.reset();
        this.arquivoAnexado.nativeElement.value = '';
    }

    retirarTipoDocLista(tipoArquivoKey) {
        this.tipoDocumentos = this.tipoDocumentos.filter(doc => doc !== tipoArquivoKey);
        this.deletedKeys.push(tipoArquivoKey);
    }
    downloadFile(documentoDTO: DocumentoDTO) {
        if(documentoDTO.id){
            this.blocker.start()
            this.documentoService.downloadDocs(documentoDTO.key).subscribe(data => {
                const newBlob =  new Blob([data], { type: "application/pdf" });
                const blobUrl = window.URL.createObjectURL(newBlob);
                window.open(blobUrl, '_blank');
                this.blocker.stop();
            },error =>  this.blocker.stop());
        }else{
            const blob = new Blob([documentoDTO.arquivo], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            window.open(url);
        }
    }
}
